

import { createSlice } from '@reduxjs/toolkit';


const initialState = {
    data:     [],   // groups (firmware history, device assignments, etc.) — populated from server
    progress: {},   // transient per-device download state, keyed by deviceID:
                    //   { [deviceID]: { pct, phase: 'in_progress' | 'success' | 'failed', message? } }
                    // populated live by socket events; not persisted.
};

const otasSlice = createSlice({
    name: 'otas',
    initialState,
    reducers: {
        setOta: (state, action) => {
            state.data = action.payload;
        },
        setDeviceProgress: (state, action) => {
            const { deviceID, entry } = action.payload;
            if (!deviceID) return;
            state.progress[deviceID] = entry;
        },
        clearDeviceProgress: (state, action) => {
            const { deviceID } = action.payload || {};
            if (!deviceID) return;
            delete state.progress[deviceID];
        },
    },
});

export const { setOta, setDeviceProgress, clearDeviceProgress } = otasSlice.actions;
export default otasSlice.reducer;